import { LanguageService } from "../services/language.service";
import { LoadingService } from "../services/loading.service";
import { ServiceLocator } from "./service-locator";

// tslint:disable-next-line: ban-types
export function ShowLoading(message?: string): Function {
  let loadingService: LoadingService;
  let languageService: LanguageService;

  // tslint:disable-next-line: ban-types
  function getMonkeyPatchMethod(method: Function): Function {
    return function (this: any, ...args: any[]) {
      if (!loadingService)
        loadingService = ServiceLocator.get<LoadingService>(LoadingService);
      if (!languageService)
        languageService = ServiceLocator.get<LanguageService>(LanguageService);
      if (!message)
        message = languageService.getTranslation('general.please-wait', 'Please wait...');
      return loadingService.wrap(() => method.apply(this, args), { message })
    };
  }

  // tslint:disable-next-line: only-arrow-functions
  return function (
    target: any,
    methodName: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    if (
      typeof originalMethod !== 'function' ||
      originalMethod.__showLoadingApplied === true
    ) {
      return;
    }
    descriptor.value = getMonkeyPatchMethod(descriptor.value);
    originalMethod.__showLoadingApplied = true;
  };
}
